import { createAction, emptyProps, props } from '@ngrx/store';
import type { User } from './auth.model';
import { VerifyOTPPayload } from '@core/interface/core';

// login action
export const login = createAction(
  '[Authentication] Login',
  props<{ email: string; password: string }>()
);
export const loginSuccess = createAction(
  '[Authentication] Login Success',
  props<{ user: User }>()
);
export const loginFailure = createAction(
  '[Authentication] Login Failure',
  props<{ error: string }>()
);

export const createPass = createAction(
  '[Authentication] CreatePass',
  props<{ email: string; password: string; token: string }>()
);

export const createPassSuccess = createAction(
  '[Authentication] CreatePass Success',
  props<{ message: string }>()
);

export const createPassFailure = createAction(
  '[Authentication] CreatePass Failure',
  props<{ error: string; message: string }>()
);

export const forgotPass = createAction(
  '[Authentication] Forgot Pass',
  props<{ email: string }>()
);

export const forgotPassSuccess = createAction(
  '[Authentication] Forgot Pass Success',
  props<{ message: string; success: boolean }>()
);

export const forgotPassFailure = createAction(
  '[Authentication] Forgot Pass Failure',
  props<{ error: string; message: string; success: boolean }>()
);

export const verifyOTP = createAction(
  '[Authentication] Verify OTP',
  props<VerifyOTPPayload>()
);

export const verifyOTPSuccess = createAction(
  '[Authentication] Verify OTP Success',
  props<{ message: string; success: boolean }>()
);

export const verifyOTPFailure = createAction(
  '[Authentication] Verify OTP Failure',
  props<{ error: string; message: string; success: boolean }>()
);

export const resetFlags = createAction(
  '[Authentication] Reset Flags',
  emptyProps
);

// logout action
export const logout = createAction('[Authentication] Logout');

export const logoutSuccess = createAction('[Auth] Logout Success');
